module.exports = __webpack_public_path__ + "static/media/home-service-slider-6.c3b9c6be.jpg";